import { UserProperties, UserProperty } from '@futrli-sdk/users';

/**
 * Checks if a property is valid, basically checks its type
 * against the UserProperties enum.
 *
 * @param {string} property
 * @returns {boolean}
 */
export const isPropertyValid = (property: string): boolean => Object.values<string>(UserProperties).includes(property);

/**
 * Finds a property in collection of properties.
 *
 * @param {UserProperty[]} properties
 * @param {UserProperty} property
 * @returns {UserProperty}
 */
export const findProperty = (properties: UserProperty[], property: UserProperties): UserProperty | undefined => properties.find((prop: UserProperty) => prop.property === property);

/**
 * Checks if the porperty exists, uses the above find and just checks if it's undefined.
 *
 * @param {UserPropert[]} properties
 * @param {UserProperty} property
 * @returns {boolean}
 */
export const hasProperty = (properties: UserProperty[], property: UserProperties): boolean => findProperty(properties, property) !== undefined;
